import { getSectionalCommitteeHistoryString } from './getSectionalCommitteeHistoryString.js';
import { NOMINATION_STATUS } from './constants';

export const formatDraftNominationData = async (
  nominationData,
  nominationStatusTypes,
  electionTypes,
  titlesTypes,
  stateTerritories,
  genderTypes,
  australianStatus,
  sectionalCommitteesWithCmse,
  sectionalCommitteeHistoryArray,
  nominationArray,
  candidateArray,
  nominationStateArray,
  candidateStateArray,
) => {
  if (nominationData) {
    const { name, lastName, email } = nominationData;

    const matchingCandidates = candidateArray?.filter((candidate) => {
      const nameMatch =
        candidate.attributes.name?.toLowerCase() === name?.toLowerCase() &&
        candidate.attributes.lastName?.toLowerCase() ===
          lastName?.toLowerCase();

      const emailMatch =
        email &&
        candidate.attributes.email &&
        candidate.attributes.email.toLowerCase() === email.toLowerCase();

      return nameMatch || emailMatch;
    });

    const matchingNomination =
      matchingCandidates?.length > 0
        ? nominationArray?.find(
            (nomination) =>
              nomination.attributes.nominationStatusTypeId !==
                NOMINATION_STATUS.EXPIRED &&
              matchingCandidates.some(
                (candidate) =>
                  nomination.attributes.candidateId === candidate.id,
              ),
          )
        : null;

    let nominationRoundYear = null;
    let consideredYears = null;
    let lastConsideredDate = null;

    if (matchingNomination) {
      const matchingNominationState = nominationStateArray?.find(
        (s) => s.attributes.nominationId === matchingNomination.id,
      )?.attributes;

      if (matchingNominationState) {
        nominationRoundYear =
          typeof matchingNominationState.roundYear === 'number'
            ? matchingNominationState.roundYear
            : null;
        lastConsideredDate =
          typeof matchingNominationState.lastConsideredDate === 'string'
            ? matchingNominationState.lastConsideredDate
            : null;
      }

      if (matchingCandidates?.length > 0) {
        const candidateId = matchingCandidates[0].id;
        const matchingCandidateState = candidateStateArray?.find(
          (s) => s.attributes.candidateId === candidateId,
        )?.attributes;

        if (matchingCandidateState) {
          consideredYears =
            typeof matchingCandidateState.consideredYears === 'number'
              ? matchingCandidateState.consideredYears
              : null;
        }
      }
    } else {
      nominationRoundYear = 'New';
    }

    const getSupporterType = (supporterTypeId) => {
      if (!supporterTypeId) {
        return '';
      }
      return parseInt(supporterTypeId) === 1 ? 'Personal' : 'General';
    };

    const getLabelFromJson = (jsonData) => {
      if (jsonData !== null && jsonData !== undefined) {
        if (Array.isArray(jsonData)) {
          const labelsString = jsonData.map((item) => item.label).join(', ');
          return labelsString;
        }
      }
      return null;
    };

    const getNonAasRefereeLabel = (referee) => {
      const refereeId = nominationData[`nonAasReferee${referee}Id`];
      const titleId = nominationData[`referee${referee}TitleId`] || null;
      const title = titlesTypes[titleId] || '';
      const refereeName = nominationData[`referee${referee}Name`];
      const refereeLastName = nominationData[`referee${referee}LastName`];
      const refereeEmail = nominationData[`referee${referee}Email`];

      if (refereeId?.value === 0) {
        return `${title} ${refereeName} ${refereeLastName} (${refereeEmail})`;
      }
      return refereeId?.label || '';
    };

    const nominationFormData = {
      nominationStatus: 'Draft(Unvalidated)',
      electionType: electionTypes[nominationData.electionTypeId],

      nominationRoundYear,
      consideredYears,
      lastConsideredDate,

      title: titlesTypes[nominationData.titleId],

      name:
        typeof nominationData?.name === 'string' ? nominationData.name : null,

      lastName:
        typeof nominationData?.lastName === 'string'
          ? nominationData.lastName
          : null,

      phone:
        typeof nominationData?.phone === 'string' ? nominationData.phone : null,

      address:
        typeof nominationData?.address === 'string'
          ? nominationData.address
          : null,

      email:
        typeof nominationData?.email === 'string' ? nominationData.email : null,

      stateTerritory: stateTerritories[nominationData?.stateTerritoryId],

      gender: genderTypes[nominationData?.genderId],

      otherGender:
        typeof nominationData?.otherGender === 'string'
          ? nominationData.otherGender
          : null,

      dob: typeof nominationData?.dob === 'string' ? nominationData.dob : null,

      countryOfBirth: nominationData?.countryOfBirthId?.label,

      australianStatus: australianStatus[nominationData.australianStatusId],

      postNominal:
        typeof nominationData?.postNominal === 'string'
          ? nominationData.postNominal
          : null,

      jobTitle:
        typeof nominationData?.jobTitle === 'string'
          ? nominationData.jobTitle
          : null,

      organisation:
        nominationData?.organisationId?.label?.toLowerCase() ===
          '-- my organisation is not listed --' &&
        typeof nominationData?.otherOrganisation === 'string'
          ? nominationData.otherOrganisation
          : nominationData?.organisationId?.label,
      otherOrganisation:
        typeof nominationData?.otherOrganisation === 'string'
          ? nominationData.otherOrganisation
          : null,

      phdAwardedYear: nominationData.phdAwardedYear,
      noPhd: !nominationData.phdAwardedYear,

      personalInformation:
        typeof nominationData?.personalInformation === 'string'
          ? nominationData.personalInformation
          : null,

      diverseBackground:
        typeof nominationData?.diverseBackground === 'boolean' &&
        nominationData?.diverseBackground
          ? 1
          : 0,

      nominationConsentFilePath:
        nominationData?.nominationConsentFilePath || '',

      retractedPapers: !!nominationData.retractedPapers,

      correctedPapers: !!nominationData.correctedPapers,

      publicationConcerns: !!nominationData.publicationConcerns,

      disclosureDeclarationFilePath:
        nominationData?.disclosureDeclarationFilePath || '',

      nationalityId: getLabelFromJson(nominationData?.nationalityId),

      emailEducationalInstitution: '',

      arrivalDate: nominationData?.arrivalDate,

      careerInterruption: !!nominationData.careerInterruption,

      scientificExcellence: nominationData.scientificExcellence,

      citation: nominationData?.citation ? nominationData.citation : '',

      sectionalCommittee:
        sectionalCommitteesWithCmse[nominationData.sectionalCommitteeId],

      sectionalCommitteeHistory: matchingNomination
        ? getSectionalCommitteeHistoryString(
            matchingNomination,
            sectionalCommitteeHistoryArray,
          )
        : '',

      deprecatedSectionalCommitteeLabel:
        nominationData.deprecatedSectionalCommitteeLabel ?? null,

      disciplineDescriptor: getLabelFromJson(
        nominationData.disciplineDescriptor,
      ),
      overlapCommittee: !!nominationData.overlapCommittee,

      overlapSectionalCommitteeId:
        sectionalCommitteesWithCmse[nominationData.overlapSectionalCommitteeId],

      overlapDisciplineDescriptor: getLabelFromJson(
        nominationData.overlapDisciplineDescriptor,
      ),

      interdisciplinaryCommittee: getLabelFromJson(
        nominationData.interdisciplinaryCommittee,
      ),

      proposerFellow: nominationData.proposerFellowId?.label,

      proposerSignatureFilePath: nominationData.proposerSignatureFilePath
        ? nominationData.proposerSignatureFilePath
        : '',

      seconderFellow: nominationData.seconderFellowId?.label,

      seconderSignatureFilePath: nominationData.seconderSignatureFilePath
        ? nominationData.seconderSignatureFilePath
        : '',

      supporterOneTypeId: getSupporterType(nominationData?.supporterOneTypeId),
      supporterOneFellow: nominationData?.supporterOneFellowId?.label,

      supporterOneSignatureFilePath:
        nominationData.supporterOneSignatureFilePath || '',

      supporterTwoTypeId: getSupporterType(nominationData?.supporterTwoTypeId),
      supporterTwoFellow: nominationData?.supporterTwoFellowId?.label,

      supporterTwoSignatureFileName:
        nominationData.supporterTwoSignatureFilePath || '',

      supporterThreeTypeId: getSupporterType(
        nominationData?.supporterTwoTypeId,
      ),
      supporterThreeFellow: nominationData?.supporterThreeFellowId?.label,

      supporterThreeSignatureFileName:
        nominationData.supporterThreeSignatureFilePath || '',

      supporterFourTypeId: getSupporterType(
        nominationData?.supporterFourTypeId,
      ),
      supporterFourFellow: nominationData?.supporterFourFellowId?.label,

      supporterFourSignatureFileName:
        nominationData.supporterFourSignatureFilePath || '',

      meetsConduct: !!nominationData?.meetsConduct,

      extendedCitationFilePath: nominationData.extendedCitationFilePath
        ? nominationData.extendedCitationFilePath
        : '',

      curriculumVitaeFilePath: nominationData.curriculumVitaeFilePath
        ? nominationData.curriculumVitaeFilePath
        : '',

      significantPublicationsFilePath:
        nominationData.significantPublicationsFilePath
          ? nominationData.significantPublicationsFilePath
          : '',

      publicationsFilePath: nominationData.publicationsFilePath
        ? nominationData.publicationsFilePath
        : '',

      refereeOne: nominationData?.refereeOne,
      refereeTwo: nominationData?.refereeTwo,
      refereeThree: nominationData?.refereeThree,
      refereeFour: nominationData?.refereeFour,
      refereeFive: nominationData?.refereeFive,
      refereeSix: nominationData?.refereeSix,
      refereeSeven: nominationData?.refereeSeven,
      refereeEight: nominationData?.refereeEight,
      refereeNine: nominationData?.refereeNine,

      refereeOneFellow: nominationData.refereeOneFellowId?.label,
      refereeTwoFellow: nominationData?.refereeTwoFellowId?.label,
      refereeThreeFellow: nominationData?.refereeThreeFellowId?.label,
      refereeFourFellow: nominationData?.refereeFourFellowId?.label,
      refereeFiveFellow: nominationData?.refereeFiveFellowId?.label,
      refereeSixFellow: nominationData?.refereeSixFellowId?.label,
      refereeSevenFellow: nominationData?.refereeSevenFellowId?.label,
      refereeEightFellow: nominationData?.refereeEightFellowId?.label,
      refereeNineFellow: nominationData?.refereeNineFellowId?.label,

      nonAasRefereeOne: getNonAasRefereeLabel('One'),
      nonAasRefereeTwo: getNonAasRefereeLabel('Two'),
      nonAasRefereeThree: getNonAasRefereeLabel('Three'),
      nonAasRefereeFour: getNonAasRefereeLabel('Four'),
      nonAasRefereeFive: getNonAasRefereeLabel('Five'),
      nonAasRefereeSix: getNonAasRefereeLabel('Six'),
      nonAasRefereeSeven: getNonAasRefereeLabel('Seven'),
      nonAasRefereeEight: getNonAasRefereeLabel('Eight'),
      nonAasRefereeNine: getNonAasRefereeLabel('Nine'),

      nonPreferredReferee: nominationData?.nonPreferredReferee ?? null,
    };
    return nominationFormData;
  }
};
